import {
  EDIT_ONE_WAY_FEE_ITEM_PRICE,
  GET_ONE_WAY_FEE_ITEM_PRICE,
  OneWayFeesItemPriceActionTypes,
  OneWayFeesItemPriceState
} from '../types/onewayfeesitemprice.types';
import { Reducer } from 'redux';

const initialState: OneWayFeesItemPriceState = {
  itemPrice: null,
  lastFetch: null
};

export const oneWayFeesItemPriceReducer: Reducer<OneWayFeesItemPriceState> = (
  state: OneWayFeesItemPriceState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as OneWayFeesItemPriceActionTypes).type) {
    case EDIT_ONE_WAY_FEE_ITEM_PRICE:
      return {
        itemPrice: action.payload.itemPrice,
        lastFetch: timeOfAction
      };
    case GET_ONE_WAY_FEE_ITEM_PRICE:
      return {
        itemPrice: action.payload.itemPrice,
        lastFetch: timeOfAction
      };
    default:
      return state;
  }
};